var map = {
	"./google-laurel-da-DK.svg": 36851,
	"./google-laurel-de-DE.svg": 49393,
	"./google-laurel-en-GB.svg": 37275,
	"./google-laurel-en-US.svg": 67636,
	"./google-laurel-es-ES.svg": 76387,
	"./google-laurel-es-MX.svg": 69648,
	"./google-laurel-fr-FR.svg": 84903,
	"./google-laurel-it-IT.svg": 32214,
	"./google-laurel-nb-NO.svg": 19514,
	"./google-laurel-nl-NL.svg": 65151,
	"./google-laurel-pl-PL.svg": 69859,
	"./google-laurel-pt-BR.svg": 45659,
	"./google-laurel-pt-PT.svg": 24931,
	"./google-laurel-sv-SE.svg": 2210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;